import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "../style.scss";
import { Translate } from "../../../../Enums/Tranlate";
import BaseService from "../../../../../services/BaseService";
import { useLocation, useNavigate } from "react-router-dom";
import ParkingService from "../../../../../services/ParkingService";
import ParkingSlotsService from "../../../../../services/ParkingSlotsService";
import ZoneService from "../../../../../services/ZoneService";
import { carColors } from "../../../../Enums/Fixed";
import DriversService from "../../../../../services/DriversService";

const AddParking = () => {
	const [formData, setFormData] = useState({
		name: "",
		phone: "",
		floor: "",
		vehicle_number: "",
		vehicle_color: "",
		car_image: "",
		entry_time: "",
		status: "parking",
		slot: "",
		zone: "",
		driver: "",
		entry_date: "",
	});
	// Per-field validation state for the react-select inputs.
	const [errors, setErrors] = useState({});
	const location = useLocation();
	const navigate = useNavigate();
	const [isAdd, setIsAdd] = useState(false);
	const [floorsOptions, setFloorsOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const [parkingSlotsOptions, setParkingSlotsOptions] = useState([]);
	const [driversOptions, setDriversOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const zoneService = new ZoneService();
	const parkingSlotsService = new ParkingSlotsService();
	const driversService = new DriversService();
	const parkingService = new ParkingService();

	useEffect(() => {
		zoneService.getList().then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
						floor: Number(info?.floor),
					};
				});
				setZonesOptions(data);
			}
		});
		driversService.getList().then((res) => {
			if (res?.status === 200) {
				let data = res?.data?.data?.data?.map((info) => {
					return {
						label: info?.username,
						value: info?.id,
					};
				});
				setDriversOptions(data);
			}
		});

		let item = location?.state || {};
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name: item?.client_name,
				phone: item?.client_phone,
				floor: {
					label: item?.floor,
					value: Number(item?.floor),
				},
				vehicle_number: item?.vehicle_number,
				vehicle_color: carColors?.find(
					(res) => res?.value === item?.vehicle_color,
				),
				car_image: item?.car_image || "",
				// entry_date: item?.entry_time.split("T")[0] || "",
				// entry_time: !!item?.entry_time
				// 	? item?.entry_time.split("T")[1].slice(0, 5)
				// 	: "",
				status: item?.status,
				slot: {
					label:
						lang === "en"
							? item?.parking_slot?.name_en
							: item?.parking_slot?.name_ar,
					value: item?.slot_id,
				},
				zone: {
					label: lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar,
					value: item?.zone_id,
				},
				driver: {
					label: item?.driver?.username,
					value: item?.driver_id,
				},
			});
		}
	}, []);
	useEffect(() => {
		if (!!formData?.zone?.value) {
			const result = Array.from({ length: formData?.zone?.floor }, (_, i) => ({
				label: i + 1,
				value: i + 1,
			}));
			setFloorsOptions(result);
		}
	}, [formData?.zone]);

	useEffect(() => {
		if (!!formData?.zone?.value && !!formData?.floor?.value) {
			parkingSlotsService
				.getList({
					zone_id: formData?.zone?.value,
					floor_number: formData?.floor?.value,
					status: "empty",
				})
				.then((res) => {
					if (res?.status === 200) {
						let data = res?.data?.data?.data?.map((info) => {
							return {
								label: lang === "en" ? info?.name_en : info?.name_ar,
								value: info?.id,
							};
						});
						setParkingSlotsOptions(data);
					}
				});
		}
	}, [formData?.zone, formData?.floor]);

	const submit = (e) => {
		e.preventDefault();

		// These four are react-select fields, so AvForm's own `required` rules
		// never see them — they have to be validated by hand.
		const nextErrors = {};
		if (!formData?.zone?.value) nextErrors.zone = true;
		if (!formData?.floor?.value) nextErrors.floor = true;
		if (!formData?.slot?.value) nextErrors.slot = true;
		if (!formData?.driver?.value) nextErrors.driver = true;

		setErrors(nextErrors);
		if (Object.keys(nextErrors).length) {
			// Previously this returned silently, so the button looked dead.
			toast.error(Translate[lang].field_required);
			return;
		}
		let data = {
			client_name: formData?.name,
			client_phone: formData?.phone,
			floor: `${formData?.floor?.value}`,
			vehicle_number: formData?.vehicle_number,
			slot_id: formData?.slot?.value,
			zone_id: formData?.zone?.value,
			driver_id: formData?.driver?.value,
		};
		if (!!formData?.car_image) data["car_image"] = formData?.car_image;
		if (!!formData?.vehicle_color?.value)
			data["vehicle_color"] = formData?.vehicle_color?.value;

		setLoading(true);
		if (isAdd) {
			// if (!!formData?.entry_time) {
			// 	const today = new Date();
			// 	const year = today.getFullYear();
			// 	const month = String(today.getMonth() + 1).padStart(2, "0");
			// 	const day = String(today.getDate()).padStart(2, "0");

			// 	// Construct ISO 8601 string in local time
			// 	const localISOString = `${year}-${month}-${day}T${formData?.entry_time}:00`;
			// 	data["entry_time"] = localISOString;
			// }
			parkingService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/parking");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			// if (!!formData?.entry_time) {
			// 	data[
			// 		"entry_time"
			// 	] = `${formData?.entry_date}T${formData?.entry_time}:00`;
			// }
			parkingService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/parking");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData({ ...formData, [name]: res.data.url });
			}
		});
	};

	return (
		<div>
			<AvForm className="form-horizontal add-parking" onValidSubmit={submit}>
				<div>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.parking}
								</p>
							</div>
						</Col>

						{/* Phone */}
						<Col md={6} className="mb-3">
							<label>
								{Translate[lang]?.phone}
								<span className="star-require">*</span>
							</label>
							<PhoneInput
								country={"kw"}
								className="w-100"
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
						{/* Name */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>
						{/* zone */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.zone}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) => {
									// Changing the zone invalidates the floor and slot below it.
									setFormData({ ...formData, zone: e, floor: "", slot: "" });
									setErrors((prev) => ({ ...prev, zone: false }));
								}}
							/>
							{errors?.zone && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* floor */}
						<Col md={6}>
							<label>
								{Translate[lang]?.floor}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.floor}
								name="floor"
								placeholder={Translate[lang]?.select}
								options={floorsOptions}
								onChange={(e) => {
									setFormData({ ...formData, floor: e });
									setErrors((prev) => ({ ...prev, floor: false }));
								}}
							/>
							{errors?.floor && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* Parking Slot */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.parking_slot}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.slot}
								name="slot"
								placeholder={Translate[lang]?.select}
								options={parkingSlotsOptions}
								onChange={(e) => {
									setFormData({ ...formData, slot: e });
									setErrors((prev) => ({ ...prev, slot: false }));
								}}
							/>
							{errors?.slot && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* Vehicle Number */}
						<Col md={6}>
							<label>
								{Translate[lang]?.vehicle_number}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.vehicle_number}
								bsSize="lg"
								name="vehicle_number"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.vehicle_number}
								onChange={(e) =>
									setFormData({
										...formData,
										vehicle_number: e.target.value,
									})
								}
							/>
						</Col>
						{/* Vehicle Color */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.vehicle_color}
							</label>
							<Select
								value={formData?.vehicle_color}
								name="vehicle_color"
								placeholder={Translate[lang]?.select}
								options={carColors}
								onChange={(e) => setFormData({ ...formData, vehicle_color: e })}
							/>
						</Col>
						{/* Driver */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.driver}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.driver}
								name="driver"
								placeholder={Translate[lang]?.select}
								options={driversOptions}
								onChange={(e) => {
									setFormData({ ...formData, driver: e });
									setErrors((prev) => ({ ...prev, driver: false }));
								}}
							/>
							{errors?.driver && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* Car Image */}
						<Col md={6}>
							<label className="text-label mb-0">
								{Translate[lang].car_image}
							</label>
							<div className="upload">
								<input
									type="file"
									name="car_image"
									id="car_image"
									onChange={(e) => fileHandler(e, "car_image")}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.car_image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.car_image && (
								<img
									src={formData?.car_image}
									alt="license_image"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>

						{/* Status */}
						<Col md={6}>
							<label className="text-label">{Translate[lang]?.status}</label>
							<div className="d-flex gap-16 mt-2">
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="parking"
										checked={formData?.status === "parking"}
										onChange={() =>
											setFormData({ ...formData, status: "parking" })
										}
									/>{" "}
									{Translate[lang]?.parking}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="leave"
										checked={formData?.status === "leave"}
										onChange={() =>
											setFormData({ ...formData, status: "leave" })
										}
									/>{" "}
									{Translate[lang]?.leave}
								</label>
							</div>
						</Col>
					</Row>
				</div>
				<div>
					<Button
						variant="primary"
						type="submit"
						className="w-50 mt-3"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.parking}
					</Button>
				</div>
			</AvForm>
		</div>
	);
};

export default AddParking;
